import { z } from "zod";

const resourceSchema = z.object({
  resourceId: z.string().min(3),
  reference: z.string(),
  comment: z.string(),
});

export const evidenceSchema = z.object({
  resources: z.array(resourceSchema).min(1).max(3),
});
